import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const SearchInput = ({ searchText, handleSearch }) => {
  return (
    <div className="input-blocks search-set mb-0">
      <div className="search-input">
        <input
          type="search"
          className="form-control form-control-sm formsearch"
          value={searchText}
          onChange={handleSearch}
        />
        <Link to="#" className="btn btn-searchset">
          <i data-feather="search" className="feather-search" />
        </Link>
      </div>
    </div>
  );
};
SearchInput.propTypes = {
    searchText: PropTypes.string.isRequired,
    handleSearch: PropTypes.func.isRequired, 
  };

export default SearchInput;
